import styled from 'styled-components';
import NextLink from 'next/link';

import { LINK_TYPE, LinkCSS } from './SharedLink';

import type { LinkProps } from './SharedLink';

const SLinkButton = styled.a<LinkProps>`
  ${LinkCSS}
`;

/**
 * Our link button styles as links.
 */
const Link = (props: LinkProps) => {
  const {
    ofType = LINK_TYPE.PRIMARY,
    fontSize = 'M14',
    href,
    children,
    shallow = false,
    disabled,
    ...rest
  } = props;

  const commonProps = {
    ofType,
    fontSize,
    disabled,
    'aria-disabled': disabled,
    ...rest,
  };

  if (href) {
    return (
      <NextLink href={href} passHref shallow={shallow} legacyBehavior>
        <SLinkButton {...commonProps}>{children}</SLinkButton>
      </NextLink>
    );
  }

  return (
    <SLinkButton href={href} {...commonProps}>
      {children}
    </SLinkButton>
  );
};

export { Link };
